import { render, staticRenderFns } from "./serverRoleLTV.vue?vue&type=template&id=59c90fe8&scoped=true&"
import script from "./serverRoleLTV.vue?vue&type=script&lang=js&"
export * from "./serverRoleLTV.vue?vue&type=script&lang=js&"
import style0 from "./serverRoleLTV.vue?vue&type=style&index=0&id=59c90fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c90fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c90fe8')) {
      api.createRecord('59c90fe8', component.options)
    } else {
      api.reload('59c90fe8', component.options)
    }
    module.hot.accept("./serverRoleLTV.vue?vue&type=template&id=59c90fe8&scoped=true&", function () {
      api.rerender('59c90fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverRoleLTV.vue"
export default component.exports